import { PrintUtilsBase, StateTypes, TempDataToRestore } from "@ortho-next/nextray-core";
import { Main } from "../Core/Main";
import { Context } from "../States/Context";
import { PrintStateTypes } from "../States/State";

/**
 * Print phase used to generate custom image.
 */
export interface PrintResult {
	[name: string]: string | undefined;
	deformity?: string;
	templating?: string;
}

/**
 * Generates images for use in the print report.
 */
export class PrintUtils extends PrintUtilsBase {
	protected declare _main: Main;
	protected declare _context: Context;

	constructor(main: Main, context: Context) {
		super(main, context);
	}

	/**
	 * Generates two images (EOC and Templating).
	 */
	public generateImages(stateType: StateTypes): PrintResult {
		const printResult: PrintResult = {};
		const tempData: TempDataToRestore = {};

		this.getRestoreData(tempData);
		if (this._main.hasAP && this._main.hasLT) {
			this._main.multiViewsActive = true;
		}
		this.applyResize(850, 750);

		stateType >= StateTypes.deformityAnalysis && (printResult.deformity = this.generateImage(PrintStateTypes.deformityAnalysis));
		stateType >= StateTypes.EOC && (printResult.templating = this.generateImage(PrintStateTypes.defAnalysisNext));

		this.restoreData(tempData);

		return printResult;
	}
}
